import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { matchPath } from 'react-router';
import intl from 'react-intl-universal';
import cloneDeep from 'lodash.clonedeep';
import isEmpty from 'lodash.isempty';
import escape from 'lodash.escape';
import { uniqBy } from 'lodash';
import { withSnackbar } from 'notistack';

import {
  selectDetailView,
  sendMessage,
  selectMenuAndReset,
  switchView,
  upLoadAttachment,
  resetAttachments,
  resetComposeId,
  deleteAttachment,
  downloadAttachment,
  selectMessage,
  clearResumeDraft,
  setComposeId,
  deleteMessages,
  deleteDraftMessages,
} from '../state/messagingActions';
import {
  AUTOCOMPLETE_MESSAGING_EMAIL_LIMIT,
  AUTOCOMPLETE_MESSAGING_CASES_LIMIT,
  MAX_ATTACHMENT_SIZE,
  MESSAGEBOX_VIEWS,
  MESSAGEDETAIL_TYPES,
  MESSAGING_COMPOSE_AUTOFILL_URL,
} from 'src/constants/constants';
import ComposeMsgPres from '../presentational/ComposeMsgPres';
import { ConfirmDialog } from 'src/ui/library/Dialog';
import { searchCases, searchParties, getCaseAndContactInfo } from 'src/services/messages.service';
import {
  getMeta,
  getMessageShown,
  checkIsReplyView,
  checkIsDraftView,
  checkIsForwardView,
} from 'src/ui/features/Messaging/state/messagingReselect';
import { transformToVals, transformCaseVals, convertModelToFormData } from 'src/helpers';
import { formatReplyDate } from 'src/helpers/date';
import Spinner from 'src/ui/library/Spinner/Spinner';
import { MESSAGING_URL } from 'src/constants/constants';

class ComposeViewContainer extends Component {
  sendCancelSaveFlag = false;

  static propTypes = {
    detailType: PropTypes.string.isRequired,
    selectedMenu: PropTypes.string.isRequired,
    meta: PropTypes.object.isRequired,
    messageData: PropTypes.object,
    userInfo: PropTypes.object,
  };

  constructor(props) {
    super(props);
    const match = matchPath(window.location.pathname, {
      path: MESSAGING_COMPOSE_AUTOFILL_URL,
      exact: false,
      strict: false,
    });
    this.state = {
      ...this.getInitialValues(props),
      renderCount: 0,
      isBeingSent: false,
      isDraftClicked: false,
      isLoading: false,
      match: match,
    };
  }

  componentDidMount() {
    const { match } = this.state;
    let { caseId, contactInfo, casePill } = this.props;
    let contactId,
      entityType = null;

    if (match || caseId || contactInfo) {
      if (match && ('caseId' in match.params || 'contactId' in match.params || 'entityType' in match.params)) {
        contactId = match.params.contactId;
        caseId = match.params.caseId;
        entityType = match.params.entityType;

        contactId = contactId && contactId !== 'undefined' && contactId !== 'null' ? contactId : null;
        caseId = caseId && caseId !== 'undefined' && caseId !== 'null' ? caseId : null;
      } else if (contactInfo) {
        contactId = contactInfo.contactId;
        entityType = contactInfo.entityType;
      }

      getCaseAndContactInfo(caseId, contactId, entityType).then(result => {
        if (result && !result.error) {
          this.setState({ caseInfo: result.caseInfo, caseContactInfo: result.contactInfo }, () => {
            this.setState({ ...this.getInitialValues(this.props), isLoading: false });
          });
        } else {
          this.setState({ isLoading: false });
        }
      });
    }

    if (casePill !== undefined && casePill !== null && casePill !== '') {
      this.searchCaseToAutoFill(casePill);
    }
  }

  componentWillUnmount() {
    selectDetailView(MESSAGEDETAIL_TYPES.VIEWMESSAGE);

    const { detailType } = this.props;

    if (!this.sendCancelSaveFlag && this.checkSendable() && !this.state.isDraftLink) {
      this.sendCancelSaveFlag = false;
      this.setState({ isChanged: false });
      this.handleDraftSave(true);
      if (detailType !== MESSAGEDETAIL_TYPES.DRAFT) {
        this.cancelCompose();
      }
    } else if (
      detailType === MESSAGEDETAIL_TYPES.FORWARD ||
      detailType === MESSAGEDETAIL_TYPES.REPLY_TO_ALL ||
      detailType === MESSAGEDETAIL_TYPES.COMPOSE
    ) {
      this.cancelCompose();
    }
    this.setState({ isDraftLink: false, isDraftClicked: false });
  }

  componentDidUpdate(prevProps) {
    const { attachments } = this.state;
    const { composeId, casePill } = this.props;

    if (this.props.casePill !== prevProps.casePill) {
      if (casePill !== undefined && casePill !== null) {
        this.searchCaseToAutoFill(casePill);
      } else {
        let modelObj = null;
        modelObj = {
          caseId: '',
          isChanged: true,
          isSendable: this.checkSendable('caseId', ''),
        };
        this.setState(modelObj);
      }
    }

    if (composeId && prevProps.composeId !== composeId && attachments.length > 1) {
      const remaining = attachments.slice();

      while (remaining.length > 0 && !remaining[0].file) {
        remaining.shift();
      }
      remaining.shift();

      remaining.forEach(file => {
        const data = new FormData();

        data.append('messageId', composeId);
        data.append('attachmentData', file.file);
        this.props.upLoadAttachment(data, progress => {
          this.setState(prevState => ({
            attachments: prevState.attachments.map(a => (a.id === file.id ? { ...a, progress } : a)),
          }));
        });
      });
    }

    if (
      !isEmpty(this.props.messageData) &&
      this.props.detailType === MESSAGEDETAIL_TYPES.DRAFT &&
      prevProps.messageData.id !== this.props.messageData.id
    ) {
      this.setState({ ...this.getInitialValues(this.props), renderCount: this.state.renderCount + 1 });
    }
  }

  searchCaseToAutoFill = caseNumber => {
    searchCases(caseNumber, AUTOCOMPLETE_MESSAGING_CASES_LIMIT, this.props.isApplicant).then(result => {
      if (result && !result.error && !result.errors) {
        this.setState({ casePillInfo: result.casesList && result.casesList.length > 0 ? result.casesList[0] : '' }, () => {
          let modelObj = null;
          if (this.state.casePillInfo) {
            let caseValue = this.state.casePillInfo.caseId;
            modelObj = {
              caseId: caseValue,
              isChanged: true,
              isSendable: this.checkSendable('caseId', caseValue),
            };
          } else {
            modelObj = {
              caseId: '',
              isChanged: true,
              isSendable: this.checkSendable('caseId', ''),
            };
          }
          this.setState(modelObj);
        });
      }
    });
  };

  setCaseId = caseId => {
    if (!caseId) return;

    const { login } = this.props;
    searchCases(caseId, AUTOCOMPLETE_MESSAGING_CASES_LIMIT, login.userRoles.applicant).then(result => {
      if (result && !result.error && !result.errors) {
        if (result.casesList) {
          const caseInfo = transformCaseVals(result.casesList[0]);
          this.setState({ initialValues: { ...this.state.initialValues, caseInfo } });
        }
      }
    });
  };

  getInitialValues = props => {
    const { detailType, composeToAddress, meta, messageData, userInfo, isCaseMessages, caseId, caseDetails, caseId2 } = props;

    const stateData = {
      to: [],
      cc: [],
      subject: '',
      caseId: '',
      body: '',
      showModal: false,
      isSendable: false,
      isChanged: false,
      attachSelected: false,
      priority: false,
      attachments: [],
      rejected: [],
      from: { id: userInfo.personId },
      selectedIndex: meta.selectedIndex,
      total: 0,
      isDraftLink: false,
    };

    if (isCaseMessages) {
      this.setCaseId(caseId);
    }

    /**
     * For sent messages: when there are no messages to show, render blank. Else, render the first message in the list.
     * For draft messages: whether or not there are messages to show, render a blank message template.
     */

    if (detailType === MESSAGEDETAIL_TYPES.COMPOSE) {
      // special case for deep linking to compose a message with pre-filled email address
      // active bug: react-connected-router is currently rendering all components twice.
      // there is no bug fix yet: https://github.com/supasate/connected-react-router/issues/193
      // because of this, the clear resume has to be commented out for now leaving the address persistant
      if (this.state && ('caseContactInfo' in this.state || 'caseInfo' in this.state)) {
        const { caseInfo, caseContactInfo } = this.state;
        const modifiedStateforCases = {
          ...stateData,
          to: caseContactInfo ? [caseContactInfo] : [],
          caseId: caseInfo ? caseInfo.caseId : null,
          initialValues: cloneDeep({
            ...stateData,
            to: [caseContactInfo],
            caseId: caseInfo ? caseInfo.caseId : null,
          }),
        };
        return modifiedStateforCases;
      }
      if (composeToAddress) {
        this.props.clearResumeDraft();
        if (caseDetails.caseId) {
          this.setCaseId(caseDetails.caseId);
        } else if (caseId2) {
          this.setCaseId(caseId2);
        }

        const modifiedStateforCases = {
          ...stateData,
          to: [composeToAddress[0].personId],
          caseId: caseDetails.caseId,
          initialValues: cloneDeep({
            ...stateData,
            to: composeToAddress,
            caseId: caseDetails.caseId,
          }),
        };
        return modifiedStateforCases;
      } else {
        return stateData;
      }
    }

    if (messageData === null || isEmpty(messageData)) {
      if (detailType === MESSAGEDETAIL_TYPES.DRAFT) {
        return {
          ...stateData,
          initialValues: cloneDeep(stateData),
        };
      }
    }

    // Handle initial values resulting from Reply, Reply to all and Forward
    let modifiedState = {};

    const toAddresses = messageData && messageData.to ? messageData.to.map(item => transformToVals(item)) : [];
    const fromAddresses = messageData && messageData.from ? messageData.from.map(item => transformToVals(item)) : [];
    const ccAddresses = messageData && messageData.cc ? messageData.cc.map(item => transformToVals(item)) : [];

    const replyTo = messageData.from && messageData.from[0];
    const replyDate = formatReplyDate(messageData.sentOn);

    const body = messageData.body ? messageData.body : '';

    if (messageData.caseId) this.setCaseId(messageData.caseId);
    // initialize state in constructor because it could be seeded with initial values for certain views
    switch (detailType) {
      case MESSAGEDETAIL_TYPES.DRAFT:
        if (messageData) {
          this.props.setComposeId(messageData.id);
        }
        modifiedState = {
          to: toAddresses,
          messageId: messageData.id,
          cc: ccAddresses,
          subject: messageData.subject,
          body: `${body}`,
          attachments: messageData.attachments ? messageData.attachments : [],
          caseId: messageData.caseDetails ? messageData.caseDetails.caseId : null,
          caseDetails: messageData.caseDetails,
        };
        break;

      case MESSAGEDETAIL_TYPES.REPLY:
        const rplSubject = 'Re: ' + this.getClearSubject(messageData.subject);
        const replyBodyHtml = `<p className="message-body-txt">On ${replyDate}, ${replyTo.name} <strong>(${replyTo.email})</strong> wrote:</p>
          <blockquote>
          ${body}
          </blockquote>
        `;

        modifiedState = {
          to: fromAddresses,
          subject: rplSubject,
          body: replyBodyHtml,
          caseId: messageData.caseDetails ? messageData.caseDetails.caseId : null,
          caseDetails: messageData.caseDetails,
          originatingId: messageData.id,
        };

        this.props.resetAttachments();

        break;

      case MESSAGEDETAIL_TYPES.REPLY_TO_ALL:
        const rplAllSubject = 'Re: ' + this.getClearSubject(messageData.subject);
        /* let replyAddresses;
        replyAddresses = [...fromAddresses, ...toAddresses].filter(item => item.email !== userInfo.email); */

        const replyAllBodyHtml = `<p className="message-body-txt">On ${replyDate}, ${replyTo.name} <strong>(${replyTo.email})</strong> wrote:</p>
          <blockquote>
          ${body}
          </blockquote>  `;

        let to = [
          ...fromAddresses,
          ...toAddresses.filter(receiver => receiver.email !== userInfo.email),
          ...(ccAddresses && ccAddresses.filter(item => item.email === userInfo.email)),
        ];

        modifiedState = {
          to: uniqBy(to, 'email'),
          cc: ccAddresses && ccAddresses.filter(item => item.email !== userInfo.email),
          subject: rplAllSubject,
          body: replyAllBodyHtml,
          caseId: messageData.caseDetails ? messageData.caseDetails.caseId : null,
          caseDetails: messageData.caseDetails,
          originatingId: messageData.id,
        };

        this.props.resetAttachments();

        break;

      case MESSAGEDETAIL_TYPES.FORWARD:
        const fwSubject = 'Fw: ' + this.getClearSubject(messageData.subject);
        const fwBodyHtml = `<br /><br /><p className="message-body-txt">On ${replyDate}, ${replyTo.name} <strong>(${
          replyTo.email
        })</strong> wrote:</p>
          ${messageData.body ? messageData.body : ''}
        `;

        modifiedState = {
          subject: fwSubject,
          body: fwBodyHtml,
          attachments: messageData.attachments ? messageData.attachments : [],
          caseId: messageData.caseDetails ? messageData.caseDetails.caseId : null,
          caseDetails: messageData.caseDetails,
          originatingId: messageData.id,
        };
        break;

      default:
        break;
    }

    const finalState = { ...stateData, ...modifiedState, priority: messageData.important };
    return { ...finalState, initialValues: cloneDeep(finalState) };
  };

  getClearSubject = () => {
    if (typeof this.props.messageData.subject !== 'undefined') {
      const clearSubject =
        this.props.messageData.subject.indexOf('Fw:') > -1 || this.props.messageData.subject.indexOf('Re:') > -1
          ? `${this.props.messageData.subject.substr(4, this.props.messageData.subject.length - 4)}`
          : `${this.props.messageData.subject}`;

      return clearSubject;
    }

    return '';
  };

  extractAddresses = data => {
    return data;
  };

  createMsgPayload = () => {
    const { isSendable, showModal, initialValues, selectedIndex, attachSelected, ...messageObj } = this.state;
    const { isReplyView, isDraftView } = this.props;

    if (isReplyView || isDraftView) {
      messageObj.to = this.extractAddresses(messageObj.to);
      messageObj.cc = this.extractAddresses(messageObj.cc);
    }

    if (messageObj.caseId && messageObj.caseId.length) {
      messageObj.caseId = messageObj.caseId;
    }

    if (!messageObj.caseId && initialValues && initialValues.caseId) {
      messageObj.caseId = initialValues.caseId;
    }

    messageObj.body = escape(messageObj.body);

    return messageObj;
  };

  checkSendable = (key, val) => {
    const fields = { ...this.state, [key]: val };
    return fields.to.length > 0 && fields.subject && fields.subject.length > 0;
  };

  handleUpdateField = (key, value) => {
    this.setState({
      [key]: value,
      isChanged: true,
      isSendable: this.checkSendable(key, value),
    });
  };

  toggleModal = status => {
    this.setState({
      showModal: status,
    });
  };

  addAttachments(messageObj) {
    const { attachments: prevAttachments, composeId } = this.props;
    const { attachments } = this.state;

    if (composeId && attachments.length) {
      messageObj = { ...messageObj, attachments: attachments.concat(prevAttachments).map(a => a.file), messageId: composeId };
    } else if (composeId) {
      messageObj = { ...messageObj, attachments: prevAttachments.map(a => a.file), messageId: composeId };
    } else if (attachments.length) {
      messageObj = { ...messageObj, attachments: attachments.map(a => a.file) };
    }

    const formData = convertModelToFormData(messageObj, new FormData(), '');
    return formData;
  }

  handleSubmit = () => {
    if (!this.state.isBeingSent) {
      this.sendCancelSaveFlag = true;
      const msgPayload = { ...this.createMsgPayload(), isSent: true };
      this.setState({ isBeingSent: true });

      this.props.sendMessage(this.addAttachments(msgPayload), intl.get('messaging.notifications.messageSent'), null, err => {
        this.setState({ isBeingSent: false });
        if (err) {
          this.props.enqueueSnackbar(err, { variant: 'error' });
        }
      });
      if (this.props.isMobile) {
        this.props.switchView(MESSAGEBOX_VIEWS.LIST);
        this.props.toggleDrawer('right');
      }
    }
  };

  handleDeleteDraft = () => {
    const { composeId } = this.props;
    this.setState({ isLoading: true, to: '' });
    this.props.deleteDraftMessages(this.props.selectedMenu, composeId, () => {
      this.setState({ isLoading: false });
      if (typeof this.props.enqueueSnackbar === 'function') {
        this.props.enqueueSnackbar(intl.get('messaging.deleteDraft.messageDeleted'), { variant: 'success' });
      }
    });
  };

  handleDraftSave = simpleSave => {
    const { detailType } = this.props;

    if (detailType === MESSAGEDETAIL_TYPES.DRAFT || !this.state.isDraftClicked) {
      if (detailType !== MESSAGEDETAIL_TYPES.DRAFT) {
        this.setState({ isDraftClicked: true });
        selectDetailView(MESSAGEDETAIL_TYPES.VIEWMESSAGE);
      }
      this.sendCancelSaveFlag = false;
      const msgPayload = { ...this.createMsgPayload(), isSent: false };

      if (!simpleSave) {
        this.setState({ isDraftLink: true });
      }
      this.props.sendMessage(this.addAttachments(msgPayload), intl.get('messaging.notifications.draftSavedSuccess'), simpleSave);
      if (this.props.isMobile) this.props.toggleDrawer('right');
    }
  };

  onRequestAccounts = val => {
    return searchParties(val, AUTOCOMPLETE_MESSAGING_EMAIL_LIMIT).then(result => {
      const data = result.emails.map((row, index) => ({ ...row, index }));
      return data;
    });
  };

  onRequestCases = val => {
    return searchCases(val, AUTOCOMPLETE_MESSAGING_CASES_LIMIT, this.props.isApplicant).then(result => {
      const data = result.casesList.map((row, index) => ({ ...row, index }));
      return data;
    });
  };

  toggleAttachment = e => {
    if (e) {
      e.stopPropagation();
    }

    this.setState(prevState => ({ attachSelected: !prevState.attachSelected }));
  };

  removeUnsupportedFile = file => {
    let remaining = this.state.rejected.reduce((total, current) => (current !== file ? [...total, current] : total), []);
    this.setState({ rejected: remaining });
  };

  attachFiles = (files, rejectedFiles) => {
    const attachments = [];
    const rejections = rejectedFiles || [];
    const totalAttachedFiles = this.state.attachments.length;
    let attachedTotal = this.state.total;

    this.toggleAttachment();
    files.forEach((file, i) => {
      attachedTotal += file.size;
      if (attachedTotal < MAX_ATTACHMENT_SIZE) {
        attachments.push({
          id: totalAttachedFiles + i,
          progress: 0,
          file,
        });
      } else {
        attachedTotal -= file.size;
        rejections.push(file);
      }
    });

    if (!(attachments.length || rejections.length)) {
      return;
    }

    const fields = { ...this.state };
    this.setState(
      prevState => ({
        rejected: prevState.rejected.concat(rejections),
        attachments: prevState.attachments.concat(attachments),
        isSendable: this.checkSendable('subject', fields.subject),
        total: attachedTotal,
      }),
      // () => {
      //   const { composeId, detailType, messageData } = this.props;

      //   if (!composeId && attachments.length > 1) {
      //     const data = new FormData();

      //     if (detailType === MESSAGEDETAIL_TYPES.DRAFT) {
      //       data.append('messageId', messageData.id);
      //     }
      //     data.append('attachmentData', attachments[0].file);
      //     this.props.upLoadAttachment(data, progress => {
      //       this.setState(prevState => ({
      //         attachments: prevState.attachments.map(a => (a.id === attachments[0].id ? { ...a, progress } : a)),
      //       }));
      //     });
      //   } else {
      //     attachments.forEach(attachment => {
      //       const data = new FormData();

      //       if (composeId) {
      //         data.append('messageId', composeId);
      //       } else if (detailType === MESSAGEDETAIL_TYPES.DRAFT) {
      //         data.append('messageId', messageData.id);
      //       }
      //       data.append('attachmentData', attachment.file);
      //       this.props.upLoadAttachment(data, progress => {
      //         this.setState(prevState => ({
      //           attachments: prevState.attachments.map(a => (a.id === attachment.id ? { ...a, progress } : a)),
      //         }));
      //       });
      //     });
      //   }
      // },
    );
  };

  cancelCompose = () => {
    this.sendCancelSaveFlag = true;
    const {
      composeId,
      resetAttachments,
      detailType,
      selectDetailView,
      isMobile,
      toggleDrawer,
      selectMenuAndReset,
      selectedMenu,
    } = this.props;

    resetAttachments();

    if (detailType === MESSAGEDETAIL_TYPES.DRAFT) {
      selectMenuAndReset(selectedMenu);
      selectDetailView(MESSAGEDETAIL_TYPES.VIEWMESSAGE);
    } else {
      selectDetailView(MESSAGEDETAIL_TYPES.VIEWMESSAGE);
    }

    if (isMobile) {
      toggleDrawer('right');
    }

    if (composeId) {
      selectMessage(composeId);
    }

    if (this.state.match) {
      this.props.history.push(MESSAGING_URL);
    }

    this.toggleModal(false);
  };

  deleteAttachment = i => {
    const attachments = this.state.attachments.slice();
    const deletedFileSize = attachments[i].file ? attachments[i].file.size : attachments[i].size;
    const total = this.state.total - deletedFileSize;
    const fields = { ...this.state };

    attachments.splice(i, 1);
    this.setState(prevState => ({
      attachments,
      isSendable: this.checkSendable('subject', fields.subject),
      total: total,
    }));
    if (this.props.attachments.length === 1) {
      this.props.resetComposeId();
    }
    this.props.deleteAttachment(i);
  };

  downloadAttachment = index => {
    const { attachments } = this.props;
    const { attachments: stateAttachments } = this.state;
    let file;
    if (attachments.length >= index + 1) {
      file = attachments[index];
    } else {
      file = stateAttachments[index];
    }
    const linkSource = `data:${file.mimetype};base64,${file.documentbody}`;
    const downloadLink = document.createElement('a');

    downloadLink.href = linkSource;
    downloadLink.download = file.subject;
    downloadLink.click();
  };

  // remove this if the bug is confirmed to be fixed
  updateInitialValues = () => {
    const { meta, messageData } = this.props;

    this.setState({
      to: messageData.to !== null ? messageData.to.map(item => transformToVals(item)) : [],
      messageId: messageData.id,
      cc: messageData.cc && messageData.cc.map(item => transformToVals(item)),
      subject: messageData.subject,
      body: `<br /><br />${messageData.body ? messageData.body : ''}`,
      attachments: messageData.attachments ? messageData.attachments : [],
      caseId: messageData.caseId,
      selectedIndex: meta.selectedIndex,
      initialValues: {
        to: messageData.to !== null ? messageData.to.map(item => transformToVals(item)) : [],
        messageId: messageData.id,
        cc: messageData.cc && messageData.cc.map(item => transformToVals(item)),
        subject: messageData.subject,
        body: `<br /><br />${messageData.body ? messageData.body : ''}`,
        attachments: messageData.attachments ? messageData.attachments : [],
        caseId: messageData.caseId,
        selectedIndex: meta.selectedIndex,
      },
    });
    return true;
  };

  checkInitialValues = () => {
    const { initialValues } = this.state;

    if (
      this.props.isCaseMessages ||
      this.props.isReplyView ||
      this.props.isDraftView ||
      this.props.isForwardView ||
      (this.props.detailType === MESSAGEDETAIL_TYPES.COMPOSE && initialValues && initialValues.to)
    ) {
      return initialValues;
    } else {
      return null;
    }
  };

  render() {
    const id = this.props.messageData && this.props.messageData.id ? this.props.messageData.id : 1;

    if (this.state.isLoading) {
      return <Spinner size={70} />;
    } else {
      return (
        <Fragment key={id}>
          {this.state.showModal && (
            <ConfirmDialog
              open
              title={intl.get('messaging.compose.confirmModal.title')}
              cancelText={intl.get('messaging.compose.confirmModal.cancel')}
              confirmText={intl.get('messaging.compose.confirmModal.confirm')}
              onCancel={this.cancelCompose}
              onConfirm={() => {
                this.toggleModal(false);
              }}>
              <span>{intl.get('messaging.compose.confirmModal.text')}</span>
            </ConfirmDialog>
          )}
          {this.state.to && (
            <ComposeMsgPres
              {...this.props}
              isBeingSent={this.state.isBeingSent}
              key={id + this.state.renderCount}
              caseId={this.props.caseId}
              caseInfo={this.state.caseInfo}
              isCaseMessages={this.props.isCaseMessages}
              isMobile={this.props.isMobile}
              initialValues={this.checkInitialValues()}
              isForwardView={this.props.isForwardView}
              isReplyView={this.props.isReplyView}
              isSendable={this.state.isSendable}
              onFieldUpdate={this.handleUpdateField}
              onCancel={this.toggleModal.bind(null, true)}
              onSubmit={this.handleSubmit}
              onDraftSave={this.handleDraftSave}
              onRequestAccounts={this.onRequestAccounts}
              onRequestCases={this.onRequestCases}
              removeUnsupportedFile={this.removeUnsupportedFile}
              rejected={this.state.rejected}
              attachSelected={this.state.attachSelected}
              toggleAttachment={this.toggleAttachment}
              switchView={switchView}
              attachFiles={this.attachFiles}
              attachments={this.state.attachments}
              priority={this.state.priority}
              deleteAttachment={this.deleteAttachment}
              downloadAttachment={this.downloadAttachment}
              isDraftClicked={this.state.isDraftClicked}
              to={this.state.to}
              cc={this.state.cc}
              subject={this.state.subject}
              body={this.state.body}
              caseDetails={this.state.caseDetails}
              deleteDraft={this.handleDeleteDraft}
              caseContactInfo={this.state.caseContactInfo}
              casePillInfo={this.state.casePillInfo}
            />
          )}
        </Fragment>
      );
    }
  }
}

const mapStateToProps = state => ({
  detailType: state.messaging.detailType,
  selectedMenu: state.messaging.selectedMenu,
  isMobile: state.browser.is.small || state.browser.is.extraSmall,
  isReplyView: checkIsReplyView(state),
  isDraftView: checkIsDraftView(state),
  isForwardView: checkIsForwardView(state),
  isTablet: state.browser.greaterThan.small,
  messageData: getMessageShown(state),
  meta: getMeta(state),
  composeToAddress: state.messaging.composeToAddress,
  composeId: state.messaging.composeId,
  attachments: state.messaging.attachments,
  caseDetails: state.cases.caseDetails,
  caseId2: state.messaging.caseId,
  login: state.login,
  isApplicant: state.login.userRoles.applicant,
  casePill: state.messaging.casePill,
});

const mapDispatchToProps = {
  selectDetailView,
  sendMessage,
  switchView,
  upLoadAttachment,
  resetAttachments,
  resetComposeId,
  deleteMessages,
  deleteAttachment,
  selectMessage,
  selectMenuAndReset,
  downloadAttachment,
  clearResumeDraft,
  setComposeId,
  deleteDraftMessages,
};

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(ComposeViewContainer));
